import { BookingCalendar } from "PFApp/booking/types";
import { Button } from "PFComponents/button";
import { PaginatedCollection } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "../../booking_calendars.module.scss";
import CalendarList from "../calendar_list";

type CalendarsPageProps = {
  data: PaginatedCollection<BookingCalendar[]>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
};

export const CalendarsPage = ({ data, setPage }: CalendarsPageProps) => {
  const { t } = useTranslation("bookingModule");
  const history = useHistory();

  const handleRouteToNewCalendar = () => history.push("/admin/booking/calendars/new");

  return (
    <div className={css.calendarsWrapper}>
      <CalendarList data={data} setPage={setPage} />
      <div className={css.actionWrapper}>
        <Button
          text={t("config.calendars.addButton")}
          icon="add"
          kind="tertiary"
          onClick={handleRouteToNewCalendar}
          className={css.addButton}
        />
      </div>
    </div>
  );
};
